module.exports = __webpack_public_path__ + "img/marketgrains.d7d69cd3.jpg";